import { useEffect, useReducer } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { formatTime } from '@/lib/utils/date';
import type { UserActivity } from '../types';

interface RunningTimerProps {
  activity: UserActivity | null | undefined;
}

type TimerAction =
  | { type: 'INIT'; value: number }
  | { type: 'TICK' };

function timerReducer(_state: number, action: TimerAction): number {
  switch (action.type) {
    case 'INIT':
      return action.value;
    case 'TICK':
      return _state + 1;
  }
}

export function RunningTimer({ activity }: RunningTimerProps) {
  const [runTime, dispatch] = useReducer(timerReducer, 0);

  useEffect(() => {
    if (!activity) {
      dispatch({ type: 'INIT', value: 0 });
      return;
    }

    let base = activity?.runTimeInSeconds || 0;

    if (!activity?.lastEndTime && activity?.lastStartTime) {
      const elapsedSec = Math.max(
        0,
        Math.floor(
          (Date.now() - new Date(activity.lastStartTime).getTime()) / 1000
        )
      );
      base += elapsedSec;
    }

    dispatch({ type: 'INIT', value: base });

    const interval = setInterval(() => {
      dispatch({ type: 'TICK' });
    }, 1000);

    return () => clearInterval(interval);
  }, [activity]);

  return (
    <div>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{formatTime(runTime)}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{activity?.description || '-'}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
